// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scoring-debug {\n  position: fixed;\n  left: 0;\n  top: 80px;\n}", ""]);
// Exports
module.exports = exports;
